import { Autocomplete, Backdrop, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, Grid, IconButton, Paper, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from "../../../../../components/utils/modalTable/modalTable";
import {  Delete, EditNote, PictureAsPdf, Print } from "@mui/icons-material";
import { setPDFData } from "../../../../../components/hooks/printPdf/pdfData";
import {  useNavigate } from "react-router-dom";
import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
import { CSVLink } from "react-csv";
import FastRewindIcon from '@mui/icons-material/FastRewind';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Loader from "../../../../../components/loader/loader";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
const OutletSalesReport = () => {
  const classes = useStyle()
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [rowData, setRowData] = useState(null)
  const[salesLines , setSalesLines] = useState([])
  const [open , setOpen] = useState(false)
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
  const [totalCard , setTotalCard] = useState(0) // overall amount in footer
  const [totalCash , setTotalCash] = useState(0) // overall amount in footer
  const [totalUpi , setTotalUpi] = useState(0) // overall amount in footer
  const [totalCGST , setTotalCGST] = useState(0) // overall amount in footer
  const [totalSGST , setTotalSGST] = useState(0) // overall amount in footer
  const [totalLessAmount , setTotalLessAmount] = useState(0) // overall amount in footer
  const [totalLoyal , setTotalLoyal] = useState(0) 
  const [totalReturnAmount , setTotalReturnAmount] = useState(0) // overall amount in footer
  const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const outletId = localStorage.getItem('outlet_id')
  const roleId = localStorage.getItem("role_id")
  const [openMode, setOpenMode] = useState(false)
  const [openMode1, setOpenMode1] = useState(false)
  const [openModeMixed, setOpenModeMixed] = useState(false)
  const [loading, setLoading] = useState(false);
  const [totalDiscount, setTotalDiscount] = useState(0); // Add this line
  const[mixedPayDetails , setMixedPayDetails] = useState({
    cash : 0,
    card : 0,
    upi : 0
  })
  const[mixedTotal , setMixedTotal] = useState(0);
  const [salesData, setSalesData] = useState(null);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [dateLimit, setDateLimit] = useState({
    // fromDate : roleId != 1 && roleId != 2 ? moment().format() : moment().startOf('month').format(),
    fromDate :  moment().format(),
    toDate :  moment().format()
  })
  const [activeRow, setActiveRow] = useState(null)
  const[cust, setCust] = useState(null)
  const [payMode, setPayMode] = useState("")
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [salesMan, setSalesMan] = useState([]); // salesman id
  const [options, setOptions] = useState({
      category: null,
      subCategory: null,
      salesManId: null,
    });
    const [selectedSalesMan, setSelectedSalesMan] = useState(null);
  const onEdit = (e) => {
    console.log(e.row,"rowss")
    setSalesLines(e.row.sales_lines)
    setRowData(e.row)
    setOpen(true)
  }
  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];
  const [csvLoading, setCsvLoading] = useState(false);
  
  const convertNumber = (num) => {
    if (num === 0) return 'Zero';

    let words = '';
    for (let i = 0; num > 0; i++) {
      if (num % 1000 !== 0) {
        words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
      }
      num = Math.floor(num / 1000);
    }
    return words.trim();
  };

  const convertHundreds = (num) => {
    if (num >= 100) {
      return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
    } else {
      return convertTens(num);
    }
  };

  const convertTens = (num) => {
    if (num < 10) return units[num];
    else if (num < 20) return teens[num - 10];
    else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
  };
  function handlePDF(e){
    console.log(e)
    const TotalData = {
      sub_total : e.sub_total,
      cess_amt : e.cess,
      gst: e.gst_Amt,
      totalAmount : e.tot,
      roundOff : e.roff,
    }
    const tableData = _.map(e.sales_lines, (val=>({
      pro_name : val.pro_name,
      category_name:val.category_name,
      sale_rate:val.mrp,
      qty:val.qty,
      disc1:val.dis_per,
      cgstPerc:val.gst_per,
      cgstAmnt : val.gst_amt,
      totalAmt:val.rate * val.qty,
      hsn: val.hsn,
    })))
    console.log(TotalData)
    axios.post(`/v1/outlet_sales_master/getall`,{docno : e.billNo})
    .then(res=>{
    dispatch(setPDFData({
      tableData : tableData,
      TotalData : TotalData,
      companyInfo : res.data,
      totalText : convertNumber(e.tot),
      title:'Sales Invoice',
      
    }))      
    const name = `BillNo_${e.billNo}`
    navigate(`/invoice/${name}`)  
    })
    .catch(err=>{
      console.log(err)
      dispatch(
        setSnackbar(true, "error", err.response.data.errors[0].message)
      );
    })
    
    
    // dispatch(setPDFData({
    //   tableData : e.purchase_lines,
    //   // TotalData : 
    // }))
    }
    console.log(data,"datttttttt");
    
// function handleThermal(e){
// console.log('Working!',e)
// console.log(e)

// const tableData = _.map(e.sales_lines, (val=>({
//   pro_name : val.pro_name,
//   category_name:val.category_name,
//   sale_rate:val.rate,
//   qty:val.qty,
//   disc1:val.dis_per,
//   mrp: val.mrp,
//   cgstPerc:val.gst_per,
//   cgstAmnt : val.gst_amt,
//   totalAmt:val.rate * val.qty,
//   hsn: val.hsn,
// })))
// axios.post(`/v1/outlet_sales_master/getall`,{docno : e.billNo})
// .then(res=>{
//   const TotalData = {
//     sub_total : Number(e.sub_total),
//     gst: e.gst_Amt,
//     totalAmount : Number(e.tot),
//     roundOff : e.roff,
//     returnAmnt: res.data.return_amount
//   }
  
// dispatch(setThermalData({
//   tableData : tableData,
//   TotalData : TotalData,
//   companyInfo : res.data,
//   totalText : convertNumber(e.tot),  
//   redeemedValue:  e.RetAmt,
//   lessAmount : e.lessAmount,
//   // redeemedValue : e.loyalty_redem
//   loyaltyRedeemed : e.loyalty_redem
// }))      
// dispatch(onPressButton())
// const name = `BillNo_${e.billNo}`
// navigate(`/sales/${name}`)  
// })
// .catch(err=>{
//   console.log(err)
//   dispatch(
//     setSnackbar(true, "error", err.response.data.errors[0].message)
//   );
// })
//    }

//new changed handleThermal for print bill amt

  function handleThermal(e) {
  const tableData = _.map(e.sales_lines, (val) => {
    const originalTotalAmt = Number(val.rate) * Number(val.qty);
    const discountAmount = originalTotalAmt * (Number(val.dis_per) / 100);
    const totalAmt = originalTotalAmt - discountAmount;
    const cgstAmnt = (totalAmt * Number(val.gst_per)) / 100;

    return {
      pro_name: val.pro_name,
      category_name: val.category_name,
      sale_rate: val.rate,
      qty: val.qty,
      disc1: val.dis_per,
      mrp: val.mrp,
      cgstPerc: val.gst_per,
      cgstAmnt: cgstAmnt,
      totalAmt: totalAmt, 
      hsn: val.hsn,
    };
  });

  axios.post(`/v1/outlet_sales_master/getall`, { docno: e.billNo })
    .then(res => {
      const discountValue = Number(e.lessAmount) || 0;
      const grandTotal = Number(e.tot) - discountValue;
      
      const TotalData = {
        sub_total: Number(e.sub_total), 
        gst: e.gst_Amt,
        discount: discountValue,
        totalAmount: grandTotal, 
        roundOff: e.roff,
        returnAmnt: res.data.return_amount
      };

      dispatch(setThermalData({
        tableData: tableData,
        TotalData: TotalData,
        companyInfo: res.data,
        totalText: convertNumber(grandTotal),
        redeemedValue: e.loyalty_redem,
        lessAmount: e.lessAmount
      }));

      dispatch(onPressButton());
      const name = `BillNo_${e.billNo}`;
      navigate(`/sales/${name}`);
    })
    .catch(err => {
      console.log(err);
      dispatch(
        setSnackbar(true, "error", err.response?.data?.errors?.[0]?.message || "Something went wrong")
      );
    });
}

function handleModeChange (e){
  console.log(e)
  setActiveRow(e)
  console.log(e.mode)
  if(e.mode == "mixed" || e.mode == "Mixed"){
    setOpenModeMixed(true)
    setMixedPayDetails((prev) => ({...prev, cash : e.cash_amt , card:e.card_amt , upi:e.upi_amt , }))
    setMixedTotal(e.cash_amt + e.card_amt + e.upi_amt) 
    setPayMode(e.mode)
  }else{
    setOpenMode(true)
    setMixedPayDetails((prev) => ({...prev, cash : e.cash_amt , card:e.card_amt , upi:e.upi_amt , }))
    setMixedTotal(e.cash_amt + e.card_amt + e.upi_amt) 
  }
}    
function handleModeChange1 (e){
  console.log(e)
  setActiveRow(e)
  console.log(e.mode)
  setOpenMode1(true)
  // if(e.mode == "mixed" || e.mode == "Mixed"){
  //   setOpenModeMixed(true)
  //   setMixedPayDetails((prev) => ({...prev, cash : e.cash_amt , card:e.card_amt , upi:e.upi_amt , }))
  //   setMixedTotal(e.cash_amt + e.card_amt + e.upi_amt) 
  //   setPayMode(e.mode)
  // }else{
  //   setOpenMode(true)
  //   setMixedPayDetails((prev) => ({...prev, cash : e.cash_amt , card:e.card_amt , upi:e.upi_amt , }))
  //   setMixedTotal(e.cash_amt + e.card_amt + e.upi_amt) 
  // }
}    
console.log(activeRow)
console.log(payMode)
const handleInputChange = (event) => {
  const { name, value } = event.target;
  const numericValue = value.replace(/[^0-9]/g, '');
  setMixedPayDetails((prev) => ({ ...prev, [name]: numericValue !== '' ? Number(numericValue) : 0}));
};
console.log(mixedPayDetails)
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "time",
    headerName: "Time",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "billNumber",
    headerName: "Bill No",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "sales_man_name",
    headerName: "Sales Man",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      // console.log(params)
            return(
      
              <Fragment>
              <Typography textTransform="capitalize">{params.value}</Typography>
              {/* {(roleId == 1 || roleId == 2)  && params.value!=="mixed" && */}
              {(roleId == 1 || roleId == 2) &&
      
              <IconButton onClick={()=>handleModeChange1(params.row)}><EditNote color="info"/></IconButton>
              }
            </Fragment>
            )
      
          }
  },
  {
    field: "party",
    headerName: "Customer Name",
    minWidth: 130,
    headerAlign: "center",
    flex:1,
    align: "center",
    sortable: false,
  },
  {
    field: "mobile",
    headerName: "Mobile",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "channels",
    headerName: "Channel",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "mode",
    headerName: "Payment Mode",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
// console.log(params)
      return(

        <Fragment>
        <Typography textTransform="capitalize">{params.value}</Typography>
        {/* {(roleId == 1 || roleId == 2)  && params.value!=="mixed" && */}
        {(roleId == 1 || roleId == 2) &&

        <IconButton onClick={()=>handleModeChange(params.row)}><EditNote color="info"/></IconButton>
        }
      </Fragment>
      )

    }
  },
  {
    field: "cash_amt",
    headerName: "Cash",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "card_amt",
    headerName: "Card",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "upi_amt",
    headerName: "Upi",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "transactionId",
    headerName: "Transaction Id",
    minWidth:320,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "cgst",
    headerName: "CGST",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "sgst",
    headerName: "SGST",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "splDiscount",
    headerName: "Discount Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "amt",
    headerName: "Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "lessAmount",
    headerName: "Less Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "RetAmt",
    headerName: "Return Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "loyalty_redem",
    headerName: "Loyalty Redeem",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  
  // {
  //   field: "igst",
  //   headerName: "IGST",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "cess",
  //   headerName: "Cess",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "dis",
  //   headerName: "Dis",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  {
    // field: "totalamtCount",
    field: "tot",
    headerName: "Total",
    minWidth: 130,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "view",
    headerName: "View",
    disableExport: true ,
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      // console.log(params.row)
      return (
        <div>
          <IconButton size="small" onClick={() => onEdit(params)}>
          <VisibilityIcon sx={{fontSize: 18}} />
        </IconButton>
        {/* <IconButton size="small" onClick={()=>handlePDF(params.row)}>
          <PictureAsPdf sx={{fontSize: 18}} />
        </IconButton> */}
        <IconButton size="small" onClick={()=>handleThermal(params.row)}><Print sx={{fontSize: 18}}/></IconButton>
        </div>
      );
    },
  },
  {
    field: "action",
    headerName: roleId == 2 || roleId == 1 ? "Action": "",
    disableExport: true ,
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      // console.log(params.row)
      const { row, index } = params;
      return (
        <div>

          {roleId == 2 || roleId == 1 ? 
          
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '5px' }}>
          <IconButton 
          // onClick={() => setOpenDeleteModal(true)}
          onClick={() => handleDeleteRow(row, index)} 
          aria-label="delete">
              <Delete sx={{ color: "red", fontSize: 18 }} />
          </IconButton>
      </div>
          
          :null}

        </div>

      );
    },
  },
]
console.log(data[0],"checkkk")
const rows = _.map(data,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  date1 : moment(val.created_at).format("DD-MM-YYYY"),
  billNo : val.docno,
  billNumber:val.docno.replace("_", "/").replace("_", "-").replace("_", "/"),
  party : val.party_name || "GIRLUSH",
  time:moment(val.created_at).format("hh:mm A"),
  amt : Math.round(val.amount).toFixed(0),
  // amt : Math.round(val.amount  + val.less_amount + val.loyalty_redem).toFixed(2),
  cess : val.cess_amt,
  dis : val.dis_amt || 0,
  totalamtCount: Math.round(val.final_total ).toFixed(0),
  tot:  Math.round(val.amount  - val.less_amount - val.loyalty_redem - val.return_amount).toFixed(0),
  // tot: Math.round(val.amount ).toFixed(2),
  cgst:parseFloat(val.gst_amt / 2).toFixed(0),
  sgst:parseFloat(val.gst_amt / 2).toFixed(0),
  splDiscount:parseFloat(val.discount_amount).toFixed(0),
  sales_lines:val.outletSales_lines,
  tot_amt: val.amount - val.return_amount - val.loyalty_redem - val.less_amount,
  documentNo:val?.docno,
  gst_Amt : val.gst_amt,
  roff: val.roff,
  mobile:val.mobile || "7810021106",
  documentDate:moment(val.created_at).format("DD-MM-YYYY"),
  sub_total : parseFloat(val.subtotal_amount).toFixed(0) ,
  mode:val.mode,
  sales_man_name:val.sales_man_name,
  sales_man_code:val.sales_man_code,
  card_amt : Math.round(val.card_amount) ,
  cash_amt: Math.round(val.cash_amount),
  upi_amt : Math.round(val.upi_amount) ,
  RetAmt:val.return_amount || 0,
  transactionId : val.transaction_id || '-',
  lessAmount : val.less_amount || 0,
  loyalty_redem:Math.round(val.loyalty_redem),
  channels:val.channels,
  sales_man_name: val.sales_man_name,
  dis_per:val.dis_per
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
function handleCheckBox(e){
const {name} = e.target
setPayMode(name)

}
const handleDeleteRow = (row, index) => {
  setRowToDelete(row); // Store row data to be deleted
  setDeleteIndex(index); // Store index
  setOpenDeleteModal(true); // Open the modal
};
const handleConfirmDelete = () => {
  const deleteData = {
    outlet_sales_id: rowToDelete.id, 
    outlet_id: cust !== null ? cust.id : outletId, 
    docno: rowToDelete.billNo, 
  };

  axios
    .post(`/v1/outlet_sales_master/delete`, deleteData)
    .then((res) => {
      // Handle success response
      const updatedData = [...data];
      updatedData.splice(deleteIndex, 1); // Remove the deleted row from the state
      setData(updatedData); // Update state with new data
      setOpenDeleteModal(false); // Close modal after deletion
    })
    .catch((err) => {
      console.log(err); // Handle error
    });
};
// const handleDeleteRow = (rowData, index) => {
//   setOpenDeleteModal(true)
//   console.log(rowData, index,"handleDeleteRow"); // Log the row data and index
//   const deleteData = {
//       outlet_sales_id: rowData.id, // Use rowData.id
//       outlet_id: cust !== null ? cust.id : outletId, // Use appropriate outlet id
//       docno: rowData.billNo, // Ensure docno is taken from rowData
//   };
  
//   console.log(deleteData, "delete payload"); // Log the payload

//   axios
//     .post(`/v1/outlet_sales_master/delete`, deleteData)
//     .then((res) => {
//         console.log(res); // Handle successful response
//         dispatch(setSnackbar(true, "success", "deleted successfully!")); // Show a success message
//         setOpenDeleteModal(false);
//       })
//     .catch((err) => {
//         console.log(err); // Handle error
//     });

//   const updateArr = [...data]; // Create a new array for state update
//   updateArr.splice(index, 1); // Remove the deleted item from the array
//   setData(updateArr); // Update the state
// };


// const handleDeleteRow = (e, i) => {
//     console.log(e, i);
//     const deleteData = {
//       outlet_sales_id: e.id,
//       outlet_id: e.outletid,
//       // outlet_id: cust!==null ? cust.id : outletId,
//       docno:e.docno,
//     };
//     console.log(deleteData,"dekeyef");
//     axios
//       .post(`/v1/outlet_sales_master/delete`, deleteData)
//       .then((res) => {
//         console.log(res);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//     const updateArr = [...data];
//     updateArr.splice(i, 1);
//     setData(updateArr);
//     dispatch(setSnackbar(true, "success", "deleted successfully!")); // Show a success message

//     // dispatch(setSnackbar(true, "error", "Please select salesman"));
  

//   // axios.post(`/v1/outlet_sales_screen_edit_log`,deleteData)
//   // .then((res) => {console.log(res)})
//   // .catch((err) => {
//   //   console.log(err)
//   // })
//   // const updateArr = [...data]
//   // updateArr.splice(i,1)
//   // setData(updateArr)
// };
function handleSaveMode() {
 
  const { id, tot_amt, mode } = activeRow;
  console.log(activeRow);
  if (payMode === "") {
    dispatch(setSnackbar(true, 'error', 'Choose any one mode!'));
    return;
  }
 
  if(payMode === 'mixed'){
    setOpenModeMixed(true)
  }else{
    const postData = {
      outlet_sales_id: id,
      upi_amount: payMode === 'upi' ? tot_amt : 0.00,
      cash_amount: payMode === 'cash' ? tot_amt : 0.00,
      card_amount: payMode === 'card' ? tot_amt : 0.00,
      mode: payMode,
    };  
    console.log(postData);
  
    axios.post('/v1/outlet_sales_payment', postData)
      .then(res => {
        console.log(res);
        handleOutletSalesReport();
        setPayMode("");
        setActiveRow(null);
        setOpenMode(false);
        setOpenModeMixed(false)
        dispatch(setSnackbar(true, 'success', 'Payment mode changed successfully'));
  
      })
      .catch(err => {
        console.log(err);
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
      });
  }
}

const handleSaveSalesMan = () => {
  const { documentNo,  } = activeRow;
  if (selectedSalesMan) {
    const postData = [{
      docno: documentNo,
      salesman_id: selectedSalesMan.id,
    }];
console.log(activeRow,"activeRow");

    axios
      .put('/v1/outlet_sales/change/salesman', postData)
      .then((res) => {
        console.log(res);
        // Refresh data or update state as needed
        setOpenMode1(false);
        setActiveRow(null);
        setSelectedSalesMan(null);
        handleOutletSalesReport()
        // Display success message
      })
      .catch((err) => {
        console.error(err);
        // Display error message
      });
  }
};
function handleSaveModeMixed(){
  const { id,  } = activeRow;
  if (payMode === "mixed") {
    const calculatedTotal = mixedPayDetails.upi + mixedPayDetails.cash + mixedPayDetails.card;
    if (calculatedTotal !== mixedTotal) {
      dispatch(setSnackbar(true, 'error', 'Please set the total amount correctly.'));
      return;
    }
  } 
  // console.log(payMode)
    const postDataMixed = {
      outlet_sales_id: id,
      upi_amount: mixedPayDetails.upi,
      cash_amount: mixedPayDetails.cash,
      card_amount: mixedPayDetails.card,
      mode: payMode,
    };
    console.log(postDataMixed)
    axios.post('/v1/outlet_sales_payment', postDataMixed )
      .then(res => {
        console.log(res);
        handleOutletSalesReport();
        setPayMode("");
        setActiveRow(null);
        setOpenMode(false);
        setOpenModeMixed(false)
        dispatch(setSnackbar(true, 'success', 'Payment mode changed successfully'));
      })
      .catch(err => {
        console.log(err);
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
      });

 
}
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  console.log(rowsPerPage,pageCount,page,"counts");
  
function handleOutletSalesReport(){
  setLoading(true);
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
    customer: cust!==null ? cust.id : outletId
  }
  axios.post(`/v1/reports/outlet_sales/${rowsPerPage}/${page}`, postData)
  .then(res=>{
    setData(res.data.data)
    setData1(res.data)
    // setPageCount(res.data.length)
    setPageCount(res.data.meta.pagination.total)
    console.log(res.data,"response");
    
  })
  .catch(err=>{
    // dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    setData([])
  })
  .finally(() => {
    setLoading(false); // Stop loading after request
  });
}
function getSalesMan() {
  axios
    .get(`v1/SalesMan/outlets/${cust!==null ? cust.id : outletId}`)
    .then((res) => setSalesMan(res.data))
    .catch((err) => {
      console.log(err);
      dispatch(setSnackbar(true, "error", err.response.data.error));
    });
}
  const tableHeadData = [
    { id:1, label: "S No" },
    { id:2, label: "product name" },
    // { id:3, label: "Doc No" },
    // { id:4, label: "Doc date" },
    { id:3 , label:"MRP"},
    { id:4 , label:"Gst Amnt"},
    { id:5 , label:"Disc Amnt"},
    { id:6, label:"Gst Per"},
    { id:7, label:"Disc Per"},
    { id:8 , label:"Qty"},
    { id:9 , label:"Rate"},
    {id:10, label: 'Total'},


  ];
  const tableBodyData = _.map(salesLines, (val,idx) => ({
    id:idx,
    sNo:idx+1,
    name:val.pro_name,
    docNo:val.docno,
    docDate:moment(val.docdate).format('DD-MM-YYYY'),
    Mrp:parseFloat(val.mrp).toFixed(0),
    gstAmnt:parseFloat(val.gst_amt).toFixed(0),
    splDiscount:parseFloat(val.dis_amt).toFixed(0),
    gstPer:val.gst_per,
    Qty:val.qty,
    Rate:parseFloat(val.rate).toFixed(0),
    // totalAmount :  val.dis_per === 100 ? val.qty * val.mrp : parseFloat( val.qty * val.mrp * (val.dis_per/ 100) ).toFixed(0) ,
    totalAmount: parseFloat(
      val.dis_amt > 0
        ? val.qty * val.dis_amt
        : (val.qty * val.rate) + val.gst_amt
    ).toFixed(0),
        // totalAmount : parseFloat( val.qty * val.rate + val.gst_amt).toFixed(0),
    disPer:val.dis_per || 0,

  }))
  console.log(tableBodyData,"tableBodyData");
  
const handleDownloadCSV = async () => {
  const payload = {
    from_date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
    to_date: moment(dateLimit.toDate).format("YYYY-MM-DD"),
    customer: cust ? cust.id : outletId
  };
  if (csvLoading) return; // Prevent multiple clicks

  setCsvLoading(true);

  try {
    const response = await axios.post(
      `/v1/reports/outlet_sales/all`,
      payload
    );
    const rows = response.data?.data || [];
    // Columns for CSV
    const headers = [
      "S.no", "Date", "Time", "Bill No", "Customer", "Mobile", "Payment Mode",
      "Cash", "Card", "Upi", "Transaction Id", "CGST", "SGST", "Discount Amount",
      "Amount", "Less amount", "Return Amount", "Loyalty Redeem", "Total"
    ];

    // Utility to get value from multiple possible keys
    const getValue = (row, keys, fallback = 0) => {
      for (const key of keys) {
        if (row[key] !== undefined && row[key] !== null && row[key] !== '') {
          return parseFloat(row[key]) || 0;
        }
      }
      return fallback;
    };

    // Generate data rows for CSV
    let csvRows = rows.map((row, i) => [
      i + 1,
      moment(row.createdat || row.created_at).format("DD-MM-YY"),
      moment(row.createdat || row.created_at).format("h:mm A"),
      row.docno || row.billNumber,
      row.partyname || row.customer || row.party_name || "GIRLUSH",
      row.mobile || "7810021106",
      row.mode || row.paymentMode,
      getValue(row, ["cashamount", "cash_amt", "cash_amount"]),
      getValue(row, ["cardamount", "card_amt", "card_amount"]),
      getValue(row, ["upiamount", "upi_amt", "upi_amount"]),
      row.transactionid || row.transaction_id || "-",
      (row.cgst !== undefined && row.cgst !== null && row.cgst !== '')
        ? parseFloat(row.cgst)
        : Math.round(getValue(row, ["gst_amt"]) / 2),
      (row.sgst !== undefined && row.sgst !== null && row.sgst !== '')
        ? parseFloat(row.sgst)
        : Math.round(getValue(row, ["gst_amt"]) / 2),
      Math.round(getValue(row, ["discountamount", "splDiscount", "discount_amount"])),
      getValue(row, ["amount", "amt", "amount"]),
      getValue(row, ["lessamount", "lessAmount", "less_amount"]),
      getValue(row, ["returnamount", "RetAmt", "return_amount"]),
      getValue(row, ["loyaltyredem", "loyalty_redem"]),
      getValue(row, ["finaltotal", "final_total", "tot"])
    ]);

    // Summing utility: checks all possible keys
    const sum = keys =>
      rows.reduce((acc, row) => acc + getValue(row, keys), 0);

    const totalCash = sum(["cashamount", "cash_amt", "cash_amount"]);
    const totalCard = sum(["cardamount", "card_amt", "card_amount"]);
    const totalUpi = sum(["upiamount", "upi_amt", "upi_amount"]);

    // Correct CGST total sum using per-row fallback and rounding logic
    const totalCGST = rows.reduce(
      (acc, row) =>
        acc + (
          (row.cgst !== undefined && row.cgst !== null && row.cgst !== '')
            ? parseFloat(row.cgst)
            : Math.round(getValue(row, ["gst_amt"]) / 2)
        ), 0
    );

    // Correct SGST total sum using per-row fallback and rounding logic
    const totalSGST = rows.reduce(
      (acc, row) =>
        acc + (
          (row.sgst !== undefined && row.sgst !== null && row.sgst !== '')
            ? parseFloat(row.sgst)
            : Math.round(getValue(row, ["gst_amt"]) / 2)
        ), 0
    );

    // Discount: sum of individually rounded per-row values, matching Excel logic!
    const totalDiscount = rows.reduce(
      (acc, row) => acc + Math.round(getValue(row, ["discountamount", "splDiscount", "discount_amount"])),
      0
    );

    const totalAmount = sum(["amount", "amt", "amount"]);
    const totalLessAmount = sum(["lessamount", "lessAmount", "less_amount"]);
    const totalReturnAmount = sum(["returnamount", "RetAmt", "return_amount"]);
    const totalLoyalty = sum(["loyaltyredem", "loyalty_redem"]);
    const totalFinal = sum(["finaltotal", "final_total", "tot"]);

    // Add summary row (as in your sample)
    const summaryRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      totalCash,
      totalCard,
      totalUpi,
      "",
      totalCGST,
      totalSGST,
      totalDiscount,
      totalAmount,
      totalLessAmount,
      totalReturnAmount,
      totalLoyalty,
      totalFinal
    ];

    // Compose the CSV rows array as in the Excel sample
    const csvData = [
      ["Outlet Name", cust ? cust.fullname : ""],
      ["From Date", moment(dateLimit.fromDate).format("DD-MM-YY")],
      ["To Date", moment(dateLimit.toDate).format("DD-MM-YY")],
      [],
      headers,
      ...csvRows,
      [],
      summaryRow
    ];

    // Convert rows to CSV string
    const csvContent = csvData.map(row =>
      row.map(item => `"${item !== undefined ? item : ""}"`).join(",")
    ).join("\n");

    // Trigger download
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `outlet_sales_report_${moment().format("YYYY-MM-DD")}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    dispatch(
      setSnackbar(
        true,
        "error",
        error?.response?.data?.errors?.[0]?.message || "CSV Download error"
      )
    );
  }
  finally {
    setCsvLoading(false);
  }
};


  useEffect(() => {
    // Calculate total balance amount
    setTotalFlag(true);
    let total = 0;
    let cardTotal = 0;
    let cashTotal = 0;
    let upiTotal = 0;
    let cgstTotal = 0;
    let sgstTotal = 0;
    let lessAmo = 0;
    let retAmnt = 0;
    let loyal = 0;
    let discountTotal = 0; // New variable for total discount
  console.log(data,"grandTotal");
  
    data.forEach(val => {
      total += parseFloat(val.amount);
      cardTotal += parseFloat(val.card_amount);
      cashTotal += parseFloat(val.cash_amount);
      upiTotal += parseFloat(val.upi_amount);
      cgstTotal += parseFloat(val.gst_amt / 2);
      sgstTotal += parseFloat(val.gst_amt / 2);
      lessAmo += parseFloat(val.less_amount);
      retAmnt += parseFloat(val.return_amount);
      loyal += Math.round(val.loyalty_redem);
      discountTotal += parseFloat(val.discount_amount); // Sum up discount amounts
    });
  
    setTotalAmount(parseFloat(data1.grandTotal || 0).toFixed(0));
    // setTotalAmount(total.toFixed(2));
    setTotalCard(cardTotal.toFixed(2));
    setTotalCash(cashTotal.toFixed(2));
    setTotalUpi(upiTotal.toFixed(2));
    setTotalCGST(cgstTotal.toFixed(2));
    setTotalSGST(sgstTotal.toFixed(2));
    setTotalLessAmount(lessAmo.toFixed(2));
    setTotalReturnAmount(retAmnt.toFixed(2));
    setTotalLoyal(loyal.toFixed(2));
    setTotalDiscount(discountTotal.toFixed(2)); // Store the total discount
  }, [data]);
  
  console.log(totalLoyal);
  
// useEffect(() => {
//   // Calculate total balance amount
//   setTotalFlag(true)
//   let total = 0;
//   let cardTotal = 0
//   let cashTotal = 0
//   let upiTotal = 0 
//   let cgstTotal = 0
//   let sgstTotal = 0
//   let lessAmo = 0
//   let retAmnt = 0
//   let loyal = 0

//   data.forEach(val => {
//       total += parseFloat(val.amount);
//       cardTotal += parseFloat(val.card_amount)
//       cashTotal += parseFloat(val.cash_amount)
//       upiTotal += parseFloat(val.upi_amount)
//       cgstTotal += parseFloat(val.gst_amt /2)
//       sgstTotal += parseFloat(val.gst_amt / 2)
//       lessAmo += parseFloat(val.less_amount)
//       retAmnt += parseFloat(val.return_amount)
//       loyal += Math.round(val.loyalty_redem)
//   });
//   setTotalAmount(total.toFixed(2))
//   setTotalCard(cardTotal.toFixed(2))
//   setTotalCash(cashTotal.toFixed(2))
//   setTotalUpi(upiTotal.toFixed(2))
//   setTotalCGST(cgstTotal.toFixed(2))
//   setTotalSGST(sgstTotal.toFixed(2))
//   setTotalLessAmount(lessAmo.toFixed(2))
//   setTotalReturnAmount(retAmnt.toFixed(2))
//   setTotalLoyal(loyal.toFixed(2))
// }, [data]);
console.log(totalLoyal)
useEffect(() => {
    getSupplierData();
  }, []);
  console.log(data)
  
  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleOutletSalesReport()
      getSalesMan()
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit, cust])
  const totalAmountMixed =  Number(mixedPayDetails.card) + Number(mixedPayDetails.cash) + Number(mixedPayDetails.upi);

  return (
    <Fragment>
      <Helmet><title>Outlet Sales Reports</title></Helmet>
      <Typography variant="h6">Outlet Sales Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname} 
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"
            InputProps={{
              ...params.InputProps,
              readOnly: true,
            }}  
            />}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              disabled={roleId != 1 && roleId != 2} 
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              disabled={roleId != 1 && roleId != 2} 
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3} style={{ display: 'flex', alignItems: 'center' }}>
        {/* <CSVLink
          data={generateCSVData(dateLimit.fromDate, dateLimit.toDate, cust)}
          filename={`outlet_sales_report_${moment().format("YYYY-MM-DD")}.csv`}
        >
          <Button variant="contained">Download CSV</Button>
        </CSVLink> */}
        
{/* <Grid item md={3} style={{ display: 'flex', alignItems: 'center' }}> */}
  <Button
    variant="contained"
    color="primary"
    onClick={handleDownloadCSV}
    sx={{ width: "160px",height :"50" ,fontSize: "16px" }}
  >
    {/* Download CSV */}
    {csvLoading ? <CircularProgress size={24} color="inherit" /> : 'Download CSV'}
  </Button>
{/* </Grid> */}

        </Grid>
      </Grid>
      <Box position="relative" width="100%">
        {/* Table Container */}
        <Paper elevation={2}>
        <CustomTable props={props}/>
        </Paper>
        
        {/* Loader Overlay */}
        {loading && (
          <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            position="absolute" 
            top={0} 
            left={0} 
            right={0} 
            bottom={0} 
            bgcolor="rgba(255, 255, 255, 0.7)" // Optional: background color for the overlay
            zIndex={1}
          >
            <CircularProgress size={50}/> {/* Material UI spinner */}
          </Box>
        )}
      </Box>
    
     
      <Dialog open={openMode} >
        <DialogTitle>Mode of Pay</DialogTitle>
        <DialogContent sx={{width:400}}>
        <Grid container>
          <Grid item xs><FormControlLabel name="cash" label="Cash" onChange={handleCheckBox} control={<Checkbox checked={payMode==='cash'}/>}/></Grid>
          <Grid item xs><FormControlLabel name="card" label="Card" onChange={handleCheckBox} control={<Checkbox checked={payMode==='card'}/>}/></Grid>
          <Grid item xs><FormControlLabel name="upi" label="UPI" onChange={handleCheckBox} control={<Checkbox checked={payMode==='upi'}/>}/></Grid>
          <Grid item xs><FormControlLabel name="mixed" label="Mixed" onChange={handleCheckBox} control={<Checkbox checked={payMode==='mixed'}/>}/></Grid>
        </Grid>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={()=> {
            setOpenMode(false)
            setPayMode("")
            }}>Cancel</Button>
          <Button size="small" variant="contained" onClick={handleSaveMode}>Save</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openMode1} >
        {/* <DialogTitle>Select Sales Man</DialogTitle> */}
        <DialogTitle>Bill No <strong>{activeRow?.documentNo}</strong></DialogTitle>
        <DialogContent sx={{width:400}}>

          <Autocomplete
        id="salesman"
        options={salesMan}
        getOptionLabel={(option) =>
          `${option.sales_man_name} - ${option.sales_man_code}`
        }
        value={selectedSalesMan}
        onChange={(event, newValue) => {
          setSelectedSalesMan(newValue);
        }}
        renderInput={(params) => (
          <TextField {...params} label="Select Sales Man" autoComplete="off" />
        )}
                      />
     
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={()=> {
            setOpenMode1(false)

            }}>Cancel</Button>
          <Button size="small" variant="contained" onClick={handleSaveSalesMan}>Save</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openModeMixed} >
        <DialogTitle>
          Mixed Pay 
          <Divider />
          <Typography sx={{marginTop:"10px",textAlign:"end",fontWeight:"bold"}}>Total Amount : {mixedTotal}</Typography>
          </DialogTitle>
        <DialogContent sx={{width:400}}>
        <Grid container>
        <TextField
                    margin="dense"
                    name="cash"
                    label="Cash Amount"
                    fullWidth
                    value={mixedPayDetails.cash}
                    onChange={handleInputChange}
                  />
                  <TextField
                    margin="dense"
                    name="card"
                    label="Card Amount"
                    fullWidth
                    value={mixedPayDetails.card}
                    onChange={handleInputChange}
                  />
                
                  <TextField
                    margin="dense"
                    name="upi"
                    label="UPI Amount"
                    fullWidth
                    value={mixedPayDetails.upi}
                    onChange={handleInputChange}
                  />
                   <Typography sx={{marginTop:"10px",textAlign:"end",fontWeight:"bold"}}>Your current Total Amount : {totalAmountMixed}</Typography>
          {/* <Grid item xs><FormControlLabel name="cash" label="Cash" onChange={handleCheckBox} control={<Checkbox checked={payMode==='cash'}/>}/></Grid>
          <Grid item xs><FormControlLabel name="card" label="Card" onChange={handleCheckBox} control={<Checkbox checked={payMode==='card'}/>}/></Grid>
          <Grid item xs><FormControlLabel name="upi" label="UPI" onChange={handleCheckBox} control={<Checkbox checked={payMode==='upi'}/>}/></Grid> */}
        </Grid>
        <Divider sx={{marginBlock:"20px"}}>Or</Divider>
       <Typography sx={{textAlign:"center",cursor:"pointer",border:"2px solid #A06EE1" ,borderRadius:"5px",fontWeight:"bold"}} onClick={() => {
        setOpenModeMixed(false);setOpenMode(true)
       }}> <IconButton sx={{marginBottom:"2px",}}><ArrowBackOutlinedIcon sx={{color:"#A06EE1"}}/></IconButton>Change mode<span style={{fontWeight:"500"}}> (Cash, Card, UPI)</span></Typography>
       {/* <Typography>"( Cash , Card , Upi)"</Typography> */}
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={()=> {
            setOpenModeMixed(false)
            setPayMode("")
            }}>Cancel</Button>
          <Button size="small" variant="contained" onClick={handleSaveModeMixed}>Save</Button>
        </DialogActions>
      </Dialog>
      <Backdrop open={open} sx={{zIndex:1450}}>
        <ModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
      <Backdrop open={openDeleteModal} sx={{zIndex:1350}} onClose={() => setOpenDeleteModal(false)}>
  <DeletePage onCancel={setOpenDeleteModal} onSubmit={handleConfirmDelete}/>
</Backdrop>
    </Fragment>
  );
};

export default OutletSalesReport;
